// Product feature switches. Plain constants (not env vars) so the same value
// is used on the server, the client and in tests, and flipping one is a
// reviewed code change.

// Utilities (bills, bill scanning, utility trends) are hidden from users while
// we decide whether to keep them. Data, API routes and services stay intact,
// so existing users' records are untouched and this flips back cleanly.
export const UTILITIES_ENABLED = false
